import { ApiMessageFile } from './File'

export interface ApiMessage {
    id: number | string
    talk_uuid?: string
    content: string
    attributes: Record<string, unknown> | null
    diff_created_time?: string
    source: 'caseworker' | 'reporter'
    type: string
    created_at: string
    caseworker_name: string | null
    files: { data: ApiMessageFile[] }
}

/** Synthetic message injected when a report has been forwarded. */
export interface SpecialForwardedMessage {
    type: 'forwarded'
    created_at: string
    to: string
}

/** Union of real API messages and synthetic UI messages. */
export type ChatMessage = ApiMessage | SpecialForwardedMessage

/** Type guard to distinguish real messages from synthetic forwarded markers. */
export const isApiMessage = (msg: ChatMessage): msg is ApiMessage =>
    msg.type !== 'forwarded' && 'id' in msg
